import api from "./api";

export interface ApiKey {
  id: string;
  chave: string;
  criadoEm: string;
  usadoEm: string | null;
}

export async function listarApiKeys() {
  const r = await api.get("/api-keys");
  return r.data.data as ApiKey[];
}

export async function gerarApiKey() {
  const r = await api.post("/api-keys");
  // Retorna a chave completa (em texto plano) só nesta resposta.
  return r.data.data as { id: string; chave: string; criadoEm: string };
}

export async function revogarApiKey(id: string) {
  await api.delete(`/api-keys/${id}`);
}
